var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0133 12.8918L14.2916 23.6134C12.9781 24.9269 11.1966 25.6648 9.3391 25.6648C7.48155 25.6648 5.70008 24.9269 4.3866 23.6134C3.07311 22.2999 2.33521 20.5185 2.33521 18.6609C2.33521 16.8034 3.07311 15.0219 4.3866 13.7084L14.3849 3.7101C15.2606 2.8329 16.4488 2.33947 17.6883 2.33838C18.9278 2.33729 20.1169 2.82861 20.9941 3.70427C21.8713 4.57992 22.3647 5.76818 22.3658 7.00764C22.3669 8.2471 21.8756 9.43623 20.9999 10.3134L10.9783 20.3118C10.5404 20.7496 9.94661 20.9956 9.32743 20.9956C8.70825 20.9956 8.11443 20.7496 7.6766 20.3118C7.23877 19.8739 6.9928 19.2801 6.9928 18.6609C6.9928 18.0418 7.23877 17.4479 7.6766 17.0101L17.5816 7.11677",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.1dd882a6181d1486c5f6faf9f278b0aa.svg";
export { ForwardRef as ReactComponent };